import { DatePipe } from '@angular/common';
import { Component, Injector, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { PermissionConstants } from 'src/app/core/constants/permission-constants.constant';
import { UserPreferenceConstants } from 'src/app/core/constants/user-preference-constants.constant';
import { UserType } from 'src/app/core/enums/user-type.enum';
import { CommonDataService } from 'src/app/core/services/common-data.service';
import { DropdownOptionsService } from 'src/app/core/services/dropdown-options.service';
import { FacilityService } from 'src/app/core/services/facility.service';
import { deepCopy, getDataScopeByPermission, getForwarderByPermission, isNullOrEmpty } from 'src/app/core/utils/common-functions';
import { SessionBaseComponent } from 'src/app/shared/components/session.base.component';
import { BookingService } from '../../services/booking.service';
import { InOutWarehousingService } from '../../services/in-out-warehousing.service';
import { CalendarComponent } from 'src/app/shared/components/calendar/calendar.component';

@Component({
  selector: 'laas-in-out-warehousing',
  templateUrl: './in-out-warehousing.component.html',
  styleUrls: ['./in-out-warehousing.component.scss']
})
export class InOutWarehousingComponent  extends SessionBaseComponent implements OnInit {

  readonly permissionCode = PermissionConstants.ViewInOutWarehousingSearch;
  readonly preferenceKey: string;
  readonly preferenceKey2 : string;
  @ViewChild('assignDate') assignDate!: CalendarComponent;

  currentLang: string = this.laasSetting.language;
  isLoading: boolean = false;
  isSearchFormOpen: boolean = true;
  searchParams: any;
  searchForm: FormGroup;
  searchResults: any[] = [];
  selectedInOutNo: any[]= [];;
  columns: any[] = [];
  letterHeadOptions: any[] = [];
  bookingForwarderOptions: any[] = [];
  inOutFeeTypeOptions : any[] = [];
  detailColumns: any[] = [];

  constructor(
    injector: Injector,
    private facilityService: FacilityService,
    private bookingService: BookingService,
    private commonDataService: CommonDataService,
    private dropdownOptionsService: DropdownOptionsService,
    private fb: FormBuilder,
    private inOutWarehousingService: InOutWarehousingService,
    private datePipe: DatePipe ) {

      super(injector);

      this.preferenceKey = UserPreferenceConstants.InOutWarehousingSearchMain;
      this.preferenceKey2 = UserPreferenceConstants.InOutWarehousingSearchDetail;

      this.searchParams = {
        inOutNoList: [],
        sourceReferenceKeyList: [],
        doNoList: [],
        facility: null,
        forwarder: null,
        assignStartDt: null,
        assignEndDt: null,
      };

      this.searchForm = this.fb.group({
        inOutNoList: [],
        sourceReferenceKeyList: [],
        doNoList: [],
        facility: null,
        forwarder: null,
        assignStartDt: null,
        assignEndDt: null,
      });

      this.columns = [
        { field: 'seqNo', header: 'Form.MainTable.SeqNo', sort: true },
        { field: 'inOutNo', header: 'Form.MainTable.InOutNo', sort: true },
        { field: 'facility', header: 'Form.MainTable.Facility', sort: true },
        { field: 'forwarder', header: 'Form.MainTable.Forwarder', sort: true },
        { field: 'billCorp', header: 'Form.MainTable.BillCorp', sort: true },
        { field: 'letterOrgId', header: 'Form.MainTable.LetterOrgId', sort: true },
        { field: 'inOutFeeType', header: 'Form.MainTable.InOutFeeType', sort: true },
        { field: 'totalCartonCnt', header: 'Form.MainTable.TotalCartonCnt', sort: true },
        { field: 'totalGrossWeight', header: 'Form.MainTable.TotalGrossWeight', sort: true },
        { field: 'totalVolumeWeight', header: 'Form.MainTable.TotalVolumeWeight', sort: true },
        { field: 'createDt', header: 'Form.MainTable.CreateDt', dataType: 'date', sort: true }
      ];

      this.detailColumns = [
        { field: 'seqNo', header: 'Form.DetailTable.SeqNo', sort: true },
        { field: 'doNo', header: 'Form.DetailTable.DoNo', sort: true },
        { field: 'sourceReferenceKey', header: 'Form.DetailTable.SourceReferenceKey', sort: true },
        { field: 'sourceReferenceType', header: 'Form.DetailTable.SourceReferenceType', sort: true },
        { field: 'createDt', header: 'Form.DetailTable.CreateDt', dataType: 'date', sort: true },
      ];

      this.inOutFeeTypeOptions = [
        { label: 'I-入倉費', value: 'I' },
        { label: 'O-出倉費', value: 'O' },
        { label: 'IO-入+進倉費', value: 'IO' },
      ];

    // 公司 orgId
    this.facilityService.getLetterOrgOptions(this.laasSetting.facility, "")
    .subscribe({
      next: (options: any[]) => {

        this.letterHeadOptions = [...options].map((x: any) => {
          return {
            label: `${x.legalEntityOUCode}-${x.legalEntityOUName} ( ${x.legalEntityReferenceCode} )`,
            value: x.legalEntityOUCode,
          };
        });
      }
    });
  }

  async ngOnInit(): Promise<void> {
    await super.ngOnInit();

    this.dropdownOptionsService.getForwarderOptions().subscribe({
      next: (options: any[]) => {
        this.bookingForwarderOptions = options.filter((x: any) => {
          return (this.userProfile.userType === UserType.SuperAdmin.toString() ||
            this.userProfile.userType === UserType.Shipping.toString() ||
            getForwarderByPermission(this.userProfile, this.permissionCode).includes(x.optionCode));
        }).map(x => ({ label: x.optionDesc, value: x.optionCode }));
      }
    });
  }

  accordionTabOpen(): void {
    this.isSearchFormOpen = true;
  }

  chipsAdd(event: any, fromControlName: any): void {
    const value: string = event.value;
    const parsedValues: string[] = value.split('\r\n').filter(x => isNullOrEmpty(x) === false && x !== '\r\n');
    const formControl = this.searchForm.get(fromControlName);
    formControl?.value.splice(formControl?.value.indexOf(value));
    formControl?.setValue(formControl?.value.concat(parsedValues));
  }

  resetBtn(){
    this.searchForm.reset();
    this.assignDate.ngOnInit();
    this.searchParams.assignStartDt = null;
    this.searchParams.assignEndDt = null;
  }

  searchBtnClick(){
    this.searchParams.assignStartDt = isNullOrEmpty(this.searchParams.assignStartDt) ? null : new Date(this.searchParams.assignStartDt).toISOString();
    this.searchParams.assignEndDt = isNullOrEmpty(this.searchParams.assignEndDt) ? null : new Date(this.searchParams.assignEndDt).toISOString();

    const params = deepCopy(this.searchParams);
    params.facility = this.laasSetting.facility;
    params.dataScopes = getDataScopeByPermission(this.userProfile, this.permissionCode);

    this.inOutWarehousingService.searchInOutWarehousing(params)
    .subscribe({
      next: result => {
        this.isSearchFormOpen = false;
        this.searchResults = result;
        this.isLoading = false
      },
      error: (err: any) => {
        this.toastErrorMessage(err.error);
      }
    });
  }

  searchDetailClick(event: any): void {
    const rowData = event.rowData;
    const isClosed = event.expanded;
    if (isClosed) {
      return;
    }
    this.inOutWarehousingService.searchInOutWarehousingDetail(rowData.inOutNo)
      .subscribe({
        next: result => {
          rowData.inOutWarehousingDetail = result;
          this.isLoading = false;
        },
        error: (err: any) => {
          this.toastErrorMessage(err.error);
        }
      });
  }

  linkClick(event: any, rowData: any): void {
    let inOutNo = rowData.inOutNo;
    this.routeStateService.navigateTo('/BillConfig/Bill', { inOutNo: inOutNo , errMsgs: [] });
  }

  dateOnChange(date: any, type: string) {
    switch (type) {
      case "assignDate":
        this.searchParams.assignStartDt = date.startDate;
        this.searchParams.assignEndDt = date.endDate;
        break;
    }
  }

}
